import React, { useState, useEffect } from 'react'

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
} from "reactstrap";

import ServicesPageHeader from "components/Headers/ServicesPageHeader.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import ServicesNavbar from 'components/Navbars/ServicesNavbar';
import ErrorBoundary from 'components/ErrorBoundary.js';
import ScrollToTop from 'components/ScrollToTop.js';
import CookieConsent from 'components/CookieConsent.js';

const Services = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const services = [
    {
      icon: "🎨",
      title: "Branding",
      description: "Create a powerful brand identity that resonates with your target audience and drives business growth.",
      image: require("assets/img/brand.jpg").default,
      features: ["Logo Design", "Brand Guidelines", "Visual Identity", "Brand Strategy"]
    },
    {
      icon: "📢",
      title: "Advertising",
      description: "Strategic advertising campaigns that reach the right audience at the right time with compelling messaging.",
      image: require("assets/img/advertising.jpg").default,
      features: ["Campaign Strategy", "Creative Development", "Media Planning", "Performance Tracking"]
    },
    {
      icon: "📱",
      title: "Digital Marketing",
      description: "Comprehensive digital marketing solutions to boost your online presence and drive conversions.",
      image: require("assets/img/marketing.jpg").default,
      features: ["SEO/SEM", "Social Media", "Email Marketing", "Analytics"]
    },
    {
      icon: "💻",
      title: "Web Development",
      description: "Custom websites and web applications built with cutting-edge technology and user experience in mind.",
      image: require("assets/img/web.jpg").default,
      features: ["Responsive Design", "E-commerce", "CMS Development", "Mobile Apps"]
    },
    {
      icon: "🎥",
      title: "Video Production",
      description: "Professional video content that tells your story and engages your audience across all platforms.",
      image: require("assets/img/video.jpg").default,
      features: ["Commercial Videos", "Social Media Content", "Live Streaming"]
    },
    {
      icon: "📸",
      title: "Photography",
      description: "High-quality photography services for products, events, and marketing materials that capture attention.",
      image: require("assets/img/photography.jpg").default,
      features: ["Product Photography", "Event Coverage", "Portrait Sessions", "Commercial Shoots"]
    },
    {
      icon: "📲",
      title: "Social Media",
      description: "Strategic social media management that builds communities and drives engagement with your brand.",
      image: require("assets/img/social.jpg").default,
      features: ["Content Creation", "Community Management", "Influencer Marketing", "Social Ads"]
    },
    {
      icon: "🎨",
      title: "Graphic Design",
      description: "Creative visual solutions that communicate your message effectively and leave a lasting impression.",
      image: require("assets/img/design.jpg").default,
      features: ["Print Design", "Digital Graphics", "UI/UX Design", "Marketing Materials"]
    },
    {
      icon: "🔍",
      title: "SEO",
      description: "Search engine optimization that improves your visibility and drives organic traffic to your website.",
      image: require("assets/img/seo.jpg").default,
      features: ["Keyword Research", "On-page SEO", "Link Building", "Local SEO"]
    },
    {
      icon: "💼",
      title: "Consultancy",
      description: "Expert business consulting to help you make informed decisions and achieve your strategic goals.",
      image: require("assets/img/consultancy.jpg").default,
      features: ["Business Strategy", "Market Analysis", "Growth Planning", "Process Optimization"]
    },
    {
      icon: "🚀",
      title: "Business Development",
      description: "Strategic business development services to expand your market reach and drive sustainable growth.",
      image: require("assets/img/content.jpg").default,
      features: ["Market Expansion", "Partnership Development", "Sales Strategy", "Revenue Growth"]
    },
    {
      icon: "💬",
      title: "SMS Marketing",
      description: "Direct SMS marketing campaigns that reach customers instantly and drive immediate engagement.",
      image: require("assets/img/businessdev.jpg").default,
      features: ["SMS Campaigns", "Customer Engagement", "Promotional Messages", "Delivery Tracking"]
    }
  ];

  return (
    <ErrorBoundary>
      <div>
        <ServicesNavbar />
        <ServicesPageHeader />

      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '100px 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Animated Background Elements */}
        <div style={{
          position: 'absolute',
          top: '10%',
          left: '5%',
          width: '200px',
          height: '200px',
          background: 'rgba(255,255,255,0.1)',
          borderRadius: '50%',
          animation: 'float 6s ease-in-out infinite'
        }}></div>
        
        <div style={{
          position: 'absolute',
          bottom: '15%',
          right: '8%',
          width: '150px',
          height: '150px',
          background: 'rgba(255,255,255,0.05)',
          borderRadius: '50%',
          animation: 'float 8s ease-in-out infinite 2s'
        }}></div>

        <Container style={{ position: 'relative', zIndex: 2 }}>
          <Row>
            <Col className="text-center">
              <div style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                transition: 'all 1s ease-out'
              }}>
                <h1 style={{
                  color: 'white',
                  fontSize: '4rem',
                  fontWeight: '700',
                  marginBottom: '30px',
                  textShadow: '0 4px 10px rgba(0,0,0,0.4)'
                }}>
                  🚀 Our Premium Services
                </h1>
                
                <h2 style={{
                  color: '#feca57',
                  fontSize: '2.5rem',
                  fontWeight: '600',
                  marginBottom: '40px',
                  textShadow: '0 2px 6px rgba(0,0,0,0.3)'
                }}>
                  Complete Digital Solutions
                </h2>

                <p style={{
                  color: 'rgba(255,255,255,0.9)',
                  fontSize: '1.4rem',
                  maxWidth: '800px',
                  margin: '0 auto 50px',
                  lineHeight: '1.8',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}>
                  We do it all, consistently and cohesively. Tri-Advise gives you considerable added value 
                  that you can rely on to move your business forward with comprehensive digital solutions.
                </p>

                <Button
                  className="btn-round"
                  style={{
                    background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                    border: 'none',
                    padding: '20px 50px',
                    borderRadius: '35px',
                    color: 'white',
                    fontWeight: '700',
                    fontSize: '1.3rem',
                    boxShadow: '0 10px 30px rgba(255, 107, 107, 0.4)',
                    transition: 'all 0.3s ease'
                  }}
                  href="#services-grid"
                >
                  Explore Our Services
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Services Grid Section */}
      <div id="services-grid" style={{
        background: 'white',
        padding: '120px 0',
        position: 'relative'
      }}>
        <Container>
          <Row>
            <Col className="text-center" style={{ marginBottom: '80px' }}>
              <h2 style={{
                color: '#333',
                fontSize: '3.5rem',
                fontWeight: '700',
                marginBottom: '30px'
              }}>
                What We Offer
              </h2>
              <div style={{
                width: '100px',
                height: '5px',
                background: 'linear-gradient(90deg, #667eea, #764ba2)',
                margin: '0 auto 40px',
                borderRadius: '3px'
              }}></div>
              <p style={{
                color: '#666',
                fontSize: '1.3rem',
                maxWidth: '700px',
                margin: '0 auto',
                lineHeight: '1.8'
              }}>
                Comprehensive digital solutions designed to elevate your business and drive measurable results
              </p>
            </Col>
          </Row>

          <Row>
            {services.map((service, index) => (
              <Col md="6" lg="4" style={{ marginBottom: '40px' }} key={index}>
                <Card style={{
                  background: 'white',
                  borderRadius: '25px',
                  border: 'none',
                  boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                  transition: 'all 0.4s ease',
                  overflow: 'hidden',
                  height: '100%'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-15px)';
                  e.currentTarget.style.boxShadow = '0 25px 50px rgba(0,0,0,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.1)';
                }}>
                  <div style={{
                    height: '250px',
                    overflow: 'hidden',
                    position: 'relative'
                  }}>
                    <img
                      alt={`${service.title} - Professional ${service.title.toLowerCase()} services by Tri-Advise`}
                      src={service.image}
                      loading="lazy"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'scale(1.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'scale(1)';
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      top: '20px',
                      left: '20px',
                      fontSize: '3rem',
                      background: 'rgba(255,255,255,0.9)',
                      borderRadius: '50%',
                      width: '70px',
                      height: '70px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 5px 15px rgba(0,0,0,0.2)'
                    }}>
                      {service.icon}
                    </div>
                  </div>
                  
                  <CardBody style={{ padding: '30px' }}>
                    <h4 style={{
                      color: '#333',
                      fontSize: '1.6rem',
                      fontWeight: '600',
                      marginBottom: '15px'
                    }}>
                      {service.title}
                    </h4>
                    
                    <p style={{
                      color: '#666',
                      fontSize: '1rem',
                      lineHeight: '1.6',
                      marginBottom: '25px'
                    }}>
                      {service.description}
                    </p>

                    <div style={{ marginBottom: '25px' }}>
                      <h6 style={{
                        color: '#333',
                        fontSize: '1rem',
                        fontWeight: '600',
                        marginBottom: '15px'
                      }}>
                        Key Features:
                      </h6>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                        {service.features.map((feature, idx) => (
                          <span key={idx} style={{
                            background: 'linear-gradient(45deg, #667eea, #764ba2)',
                            color: 'white',
                            padding: '6px 12px',
                            borderRadius: '15px',
                            fontSize: '0.8rem',
                            fontWeight: '500'
                          }}>
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>

                    <Button
                      className="btn-round"
                      style={{
                        background: 'linear-gradient(45deg, #667eea, #764ba2)',
                        border: 'none',
                        padding: '12px 30px',
                        borderRadius: '25px',
                        color: 'white',
                        fontWeight: '600',
                        fontSize: '1rem',
                        boxShadow: '0 5px 15px rgba(102, 126, 234, 0.3)',
                        transition: 'all 0.3s ease',
                        width: '100%'
                      }}
                      href="#contact"
                      aria-label={`Learn more about ${service.title} services`}
                      onFocus={(e) => {
                        e.target.style.outline = '2px solid #feca57';
                        e.target.style.outlineOffset = '2px';
                      }}
                      onBlur={(e) => {
                        e.target.style.outline = 'none';
                      }}
                    >
                      Learn More
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Call to Action Section */}
      <div style={{
        background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
        padding: '120px 0',
        textAlign: 'center'
      }}>
        <Container>
          <Row>
            <Col>
              <h2 style={{
                color: 'white',
                fontSize: '3.5rem',
                fontWeight: '700',
                marginBottom: '30px',
                textShadow: '0 4px 8px rgba(0,0,0,0.3)'
              }}>
                Ready to Transform Your Business?
              </h2>
              <p style={{
                color: 'rgba(255,255,255,0.9)',
                fontSize: '1.4rem',
                maxWidth: '700px',
                margin: '0 auto 50px',
                lineHeight: '1.8'
              }}>
                Let's discuss how our comprehensive digital solutions can drive your business forward. 
                Contact us today for a personalized consultation and custom quote!
              </p>
              
              <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', flexWrap: 'wrap' }}>
                <Button
                  className="btn-round"
                  style={{
                    background: 'linear-gradient(45deg, #25D366, #128C7E)',
                    border: 'none',
                    padding: '20px 50px',
                    borderRadius: '35px',
                    color: 'white',
                    fontWeight: '700',
                    fontSize: '1.3rem',
                    boxShadow: '0 10px 30px rgba(37, 211, 102, 0.4)',
                    transition: 'all 0.3s ease'
                  }}
                  href="https://api.whatsapp.com/send/?phone=%2B96181906656&text&type=phone_number&app_absent=0"
                  target="_blank"
                >
                  <i className="fa fa-whatsapp" style={{ marginRight: '10px' }} />
                  Get Started via WhatsApp
                </Button>

                <Button
                  className="btn-round"
                  style={{
                    background: 'rgba(255,255,255,0.2)',
                    backdropFilter: 'blur(10px)',
                    border: '2px solid white',
                    padding: '20px 50px',
                    borderRadius: '35px',
                    color: 'white',
                    fontWeight: '700',
                    fontSize: '1.3rem',
                    boxShadow: '0 10px 30px rgba(255, 255, 255, 0.2)',
                    transition: 'all 0.3s ease'
                  }}
                  href="#contact"
                >
                  <i className="fa fa-envelope" style={{ marginRight: '10px' }} />
                  Request Consultation
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add keyframes for animations */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0); }
          25% { transform: translateY(-20px) translateX(10px); }
          50% { transform: translateY(-10px) translateX(-10px); }
          75% { transform: translateY(-30px) translateX(5px); }
        }
      `}</style>

        <DemoFooter />
        <ScrollToTop />
        <CookieConsent />
      </div>
    </ErrorBoundary>
  )
}

export default Services

